import { environment } from "../config/environment";
import { clearAdminToken, getAdminToken } from "../auth/session";

export interface ApiResponse<T> {
  code: string;
  message: string;
  data: T;
  requestId: string;
}

export class ApiClientError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly code?: string,
  ) {
    super(message);
    this.name = "ApiClientError";
  }
}

export async function request<T>(
  path: string,
  init: RequestInit = {},
): Promise<ApiResponse<T>> {
  const method = (init.method ?? "GET").toUpperCase();
  const headers = new Headers(init.headers);
  headers.set("Content-Type", "application/json");
  const token = getAdminToken();
  if (token) headers.set("Authorization", `Bearer ${token}`);
  if (method !== "GET" && method !== "HEAD") {
    headers.set("x-idempotency-key", crypto.randomUUID());
  }
  const response = await fetch(`${environment.apiBaseUrl}${path}`, {
    ...init,
    credentials: "include",
    headers,
  });

  const payload = (await response.json()) as ApiResponse<T>;

  if (!response.ok) {
    if (response.status === 401) clearAdminToken();
    throw new ApiClientError(payload.message, response.status, payload.code);
  }

  return payload;
}
